<template>
  <div class="activities-result-list">
    <!-- Skeleton loaders while searching -->
    <template v-if="searchStore.searchPending && !activityList.length">
      <ActivityCardSkeleton v-for="i in 4" :key="`skel-${i}`" />
    </template>

    <!-- Activity cards -->
    <ActivityCard v-for="activity in activityList" :key="activity.id" :activity="activity" />

    <!-- Empty state -->
    <div v-if="!activityList.length && !searchStore.searchPending" class="no-results">
      <div class="no-results-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="var(--grey)"/>
        </svg>
      </div>
      <div class="no-results-title">{{ $t('No activities found') }}</div>
      <div class="no-results-message">
        {{ hasFilters ? $t('Try adjusting your filters to see more results') : $t('No activities available for this destination yet') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ActivityCard from "~/components/MarketPage/ActivityCard.vue";
import ActivityCardSkeleton from "~/components/MarketPage/ActivityCardSkeleton.vue";
import { useSearchStore } from "~/store/search";

const searchStore = useSearchStore();
const route = useRoute();

const activityList = computed(() => searchStore.activitiesProducts);

const FILTER_KEYS = ['price_gte', 'price_lte', 'rating_gte', 'categories']
const hasFilters = computed(() =>
  FILTER_KEYS.some(key => Boolean(route.query[key]))
)
</script>

<style scoped lang="scss">
.activities-result-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;

  @media screen and (max-width: 1024px) {
    width: 100%;
  }
}

.no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 24px;
  border: 1px dashed var(--grey-border);
  border-radius: 10px;
  background: var(--light-grey);
  text-align: center;

  .no-results-icon {
    font-size: 48px;
    opacity: 0.5;
  }

  .no-results-title {
    font-size: 18px;
    font-weight: 600;
    color: var(--black);
  }

  .no-results-message {
    font-size: 14px;
    color: var(--dark-grey);
    max-width: 360px;
  }
}
</style>
